export default class GuestUserPreferencesSystem {
	constructor( dispatch ) {
		this.dispatch = dispatch;
	}

	setAssetDownloadResolution() {
		return null;
	}
}
